export default __webpack_public_path__ + "static/media/information--end-of-bicycle-lane--g1.d2b5baa9.png";